<template>
  <div class="canvasContent">
    <div class="canvasContent-head"
      :style="{transform:'scale(' + scale + ') translate(' + positionX + 'px,' + positionY + 'px)'}">
      <img :src="uploadImg" alt="用户图片">
    </div>
    <img class="canvasContent-img" :class="{active: touchState}" :src="frontImg" @load="imgLoad" alt="">
    <div class="canvasContent-con"
      @touchstart="touchstart"
      @touchmove="touchmove"
      @touchend="touchend">
    </div>
  </div>
</template>

<script>
export default {
  name: 'canvasContent',
  props: {
    // （个性海报）模版图片
    frontImg: {
      type: String,
      required: true
    },
    // 用户上传/拍照图片
    uploadImg: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      initTouchX: 0, // X 轴起始位置
      initTouchY: 0, // Y 轴起始位置
      changeTouchX: 0, // 移动过程 X 坐标
      changeTouchY: 0, // 移动过程 Y 坐标
      lastTouchX: 0, // 移动结束 X 坐标
      lastTouchY: 0, // 移动结束 Y 坐标
      positionX: 0, // 图片移动的X轴位置
      positionY: 0, // 图片移动的Y轴位置
      scale: 1, // 缩放比例
      lastScale: 1, // 上次缩放比例
      touchState: false // 开始拖动图片
    }
  },
  methods: {
    imgLoad () {
      this.$toast && this.$toast.clear()
    },
    touchstart (e) {
      e.preventDefault()
      this.touchState = true
      if (e.touches.length === 1) {
        // 单指操作
        this.initTouchX = e.touches[0].clientX
        this.initTouchY = e.touches[0].clientY
      } else {
        // 多指操作
        this.initTouchX = e.touches[0].clientX - e.touches[1].clientX
        this.initTouchY = e.touches[0].clientY - e.touches[1].clientY
      }
    },
    touchmove (e) {
      e.preventDefault()
      if (e.touches.length === 1) {
        // 单指操作
        this.changeTouchX = e.touches[0].clientX - this.initTouchX
        this.changeTouchY = e.touches[0].clientY - this.initTouchY
        this.positionX = this.lastTouchX + (this.changeTouchX / this.scale)
        this.positionY = this.lastTouchY + (this.changeTouchY / this.scale)
      } else {
        // 多指操作
        this.changeTouchX = e.touches[0].clientX - e.touches[1].clientX
        this.changeTouchY = e.touches[0].clientY - e.touches[1].clientY
        const _changeNum = (this.changeTouchX - this.initTouchX) - (this.changeTouchY - this.initTouchY)
        const _scale = _changeNum ? (this.changeTouchX / this.initTouchX) * this.lastScale : (this.changeTouchY / this.initTouchY) * this.lastScale
        this.scale = _scale > 3 ? 3 : _scale < 0.5 ? 0.5 : _scale
      }
    },
    touchend (e) {
      this.lastScale = this.scale
      this.lastTouchX = this.positionX
      this.lastTouchY = this.positionY
      if (e.touches.length > 0) {
        this.initTouchX = e.touches[0].clientX
        this.initTouchY = e.touches[0].clientY
      }
      this.touchState = false
    }
  }
}
</script>

<style lang="scss" scoped>
.canvasContent {
  position: relative;
  width: 250px;
  height: 400px;
  overflow: hidden;
  background-color: #fff;
  // border-radius: 8px;
  box-shadow: 0 11px 21px 0 rgba(166, 160, 127, 0.47);

  &-con {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    height: 100%;
  }

  &-head {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &-img {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    // width: auto;
    // height: 100%;
    // width: 100%;

    &.active {
      opacity: 0.6;
    }
  }

  &-title {
    position: absolute;
    top: 34px;
    left: 0;
    z-index: 10;
    width: 100%;
    font-size: 12px;
    text-align: center;
    color: #fff;

    p {
      width: 230px;
      height: 40px;
      overflow: hidden;
      font-size: 26px;
      color: #f25227;
    }

    img {
      width: 166px;
    }
  }

  &-qrcode {
    position: absolute;
    bottom: 240/375*28px;
    right: 240/375*27px;
    // bottom: 10px;
    // left: 0;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    width: 240/375*66px;
    height: 240/375*66px;
    background: #fff;
    border-radius: 50%;

    & > img {
      position: unset;
      width: 100%;
    }

    &-desc {
      width: 150px;
      margin-left: 10px;
      overflow: hidden;
      font-size: 12px;
      font-family: "FZY4K--GBK1-0";
      text-align: left;
      color: #fff;

      p {
        height: 18px;
        overflow: hidden;
      }
    }

    &-img {
      position: absolute;
      bottom: 6px;
      right: 22px;
      width: 46px;
    }

    &-common {
      line-height: 20px;
    }
  }
}
</style>
